<div class="d-flex justify-content-center">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <span class="loadingText" *ngIf="loadingText!=''">&nbsp;{{loadingText}}</span>
</div>
